<template>
  <div>
    <div class="info">
      <div class="info-left">
        <div class="info-row">
          <div class="info-col">
            <span class="info-label">广告主公司名称</span>
            <span class="info-value">{{ dataSource.company }}</span>
          </div>
          <div class="info-col">
            <span class="info-label">客保状态</span>
            <span class="info-value">{{ dataSource.status_name }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-col">
            <span class="info-label">释放时间</span>
            <span class="info-value">
              <Tooltip :content="`${dataSource.over_at}释放`">
                <span>{{ dataSource.over_day > 30 ? 30 : dataSource.over_day }}天后释放</span>
              </Tooltip>
            </span>
          </div>
          <div class="info-col">
            <span class="info-label">归属时间</span>
            <span class="info-value">{{ dataSource.owner_at }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-col">
            <span class="info-label-1">跟进状态</span>
            <Step
              style="width: 100%"
              :item="dataSource"
              detailType="1"
              :steps="steps"
            />
          </div>
        </div>
      </div>
      <div class="info-right">
        <div class="info-row">
          <div class="info-col">
            <span class="info-label">下载次数</span>
            <span class="info-value">{{ dataSource.down_count }}</span>
          </div>
        </div>
        <div class="info-row">
          <span class="info-label">应用介绍</span>
          <span class="info-value">
            {{ desc }}
            <span v-if="desc">...</span>
            <span
              v-if="desc"
              type="text"
              style="color: #2F9EFF; cursor: pointer"
              @click="showDetail"
            >
              查看
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="info-div">
      <span @click="toggle">
        {{ show ? '收起' : '查看更多' }}
        <i :class="className" />
      </span>
    </div>
    <div
      v-if="show"
      class="info"
      style="margin-top: 32px"
    >
      <div class="info-left">
        <div class="info-row">
          <div class="info-col">
            <span class="info-label">直客销售</span>
            <span class="info-value">{{ dataSource.username }}</span>
          </div>
          <div class="info-col">
            <span class="info-label">品牌</span>
            <span class="info-value">{{ getBrand(dataSource.brand) }}</span>
          </div>
        </div>
        <div class="info-row">
          <div class="info-col">
            <span class="info-label">客户编号</span>
            <span class="info-value">{{ dataSource.customer_id }}</span>
          </div>
          <div class="info-col">
            <span class="info-label">广告账号数</span>
            <span class="info-value">{{ dataSource.account_num }}个</span>
          </div>
        </div>
      </div>
      <div class="info-right" />
    </div>
    <Dialog :visible.sync="visible">
      {{ dataSource.desc }}
    </Dialog>
  </div>
</template>

<script>
import { Tooltip, Dialog } from 'element-ui';
import { find } from 'lodash';

import Step from '../../components/Step';
import requestMixin from '../mixins/request';

export default {
  components: {
    Tooltip,
    Dialog,

    Step,
  },

  mixins: [requestMixin],

  props: {
    dataSource: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      active: 3,
      show: false,
      visible: false,
      brands: [],
      steps: [
        {
          id: '1',
          name: '跟进',
          type: '1',
        },
        {
          id: '2',
          name: '广告主接洽',
          type: '1',
        },
        {
          id: '3',
          name: '合作提案',
          type: '1',
        },
        {
          id: '4',
          name: '开户',
          type: '1',
        },
      ],
    };
  },

  computed: {
    desc() {
      return this.dataSource.desc.substring(0, 100);
    },

    className() {
      return this.show ? 'crm-icon-up-circle' : 'crm-icon-down-circle';
    },
  },

  created() {
    this.getBrands();
  },

  methods: {
    toggle() {
      this.show = !this.show;
    },

    showDetail() {
      this.visible = true;
    },

    getBrand(id) {
      const res = find(this.brands, (brand) => {
        return brand.id === id;
      });
      return res ? res.name : '其他';
    },
  },
};
</script>

<style lang="less">
.info {
  display: flex;
  font-size: 14px;

  &-left {
    flex: 2;
  }

  &-right {
    flex: 1;
  }

  &-row {
    display: flex;
  }

  &-col {
    flex: 1;
    padding: 12px 0;
    display: flex;
  }

  &-label {
    flex: 0 0 30%;
    color: rgba(144, 147, 153, 1);
    margin-right: 20px;
    text-align: right;
  }

  &-label-1 {
    flex: 0 0 15%;
    color: rgba(144, 147, 153, 1);
    margin-right: 20px;
    text-align: right;
  }

  &-value {
    flex: 1;
  }

  &-div {
    width: 200px;
    height: 1px;
    background: rgba(220, 223, 230, 1);
    border-radius: 1px;
    position: relative;
    margin: 16px auto 0;
    cursor: pointer;

    & > span {
      color: #1890ff;
      position: absolute;
      padding: 0 8px;
      background: #fff;
      font-size: 12px;
      left: 50%;
      top: -6px;
      line-height: 12px;
      transform: translateX(-50%);

      & > i {
        font-size: 12px;
        margin-left: 4px;
      }
    }
  }
}
</style>